import { Box, Grid, Card, CardContent, Typography, Button, CardMedia } from '@material-ui/core';
import { makeStyles, Theme, createStyles, alpha } from '@material-ui/core/styles';
import cs from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useCurrentUser } from '../../../Session';
import useCommonStyles from '../../../useCommonStyles';
import usePublic from '../../../utilities/usePublic';
import Transaction from './Transaction';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexWrap: 'wrap',
            display: 'flex',
        },
        card: {
            padding: 0,
            minHeight: '200px',
            display: 'flex',
        },
        cardContent: {
            display: 'flex',
            flexDirection: 'column',
            padding: 0,
            flex: 1,
            '&:last-child': {
                padding: 0,
            },
        },
        mediaInfo: {
            minHeight: '110px',
            display: 'flex',
            justifyContent: 'center',
            background: alpha(theme.palette.secondary.main, 0.1),
            alignItems: 'center',
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3),
        },
        profileInfoWrapper: {
            display: 'flex',
            flex: 1,
            justifyContent: 'center',
            minWidth: '100%',
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3),
        },
        profileInfo: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignSelf: 'center',
            alignItems: 'center',
            flex: 1,
        },
        titleWrapper: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
        },
        title: {
            color: theme.palette.secondary.main,
            fontSize: '16px',
            fontWeight: 'bold',
            maxWidth: '126px',
        },
        greetImage: {
            width: '151px',
            height: '98px',
            marginTop: 'auto',
        },
        customButton: {
            maxWidth: '293px',
            width: '100%',
        },
    })
);

const HomePageBody = () => {
    const { t } = useTranslation(['common', 'homePage']);

    const history = useHistory();
    const commonStyles = useCommonStyles();
    const styles = useStyles();
    const user = useCurrentUser();

    const image = usePublic('assets/images/greet.png');

    return (
        <Grid className={styles.root} spacing={5} container>
            <Grid lg={4} xs={12} item>
                <Card className={styles.card} elevation={0}>
                    <CardContent className={styles.cardContent}>
                        <Box className={styles.mediaInfo}>
                            <Box className={styles.titleWrapper}>
                                <Typography className={styles.title}>
                                    {t('homePage:welcomeBackUser', { name: user.fullName })}
                                </Typography>
                            </Box>
                            <CardMedia className={styles.greetImage} image={image} />
                        </Box>
                        <Grid className={styles.profileInfoWrapper} xs={10} item>
                            <Box className={styles.profileInfo}>
                                <Button
                                    className={cs(
                                        styles.customButton,
                                        commonStyles.removeBoxShadow,
                                        commonStyles.defaultBorderRadius
                                    )}
                                    color="secondary"
                                    onClick={() => history.push('/profile')}
                                    size="large"
                                    variant="contained"
                                >
                                    {t('homePage:button.viewProfile')}
                                </Button>
                            </Box>
                        </Grid>
                    </CardContent>
                </Card>
            </Grid>
            {/* <Grid lg={4} xs={12} item>
                <Transaction title={t('homePage:purchaseTransactions')}>
                    <Button
                        className={cs(
                            styles.customButton,
                            commonStyles.removeBoxShadow,
                            commonStyles.defaultBorderRadius
                        )}
                        color="secondary"
                        onClick={() => history.push('/purchaseTransactions')}
                        size="large"
                        variant="contained"
                    >
                        {t('homePage:button.viewPurchaseTransactions')}
                    </Button>
                </Transaction>
            </Grid> */}
            <Grid lg={4} xs={12} item>
                <Transaction title={t('homePage:salesTransactions')}>
                    <Button
                        className={cs(
                            styles.customButton,
                            commonStyles.removeBoxShadow,
                            commonStyles.defaultBorderRadius
                        )}
                        color="secondary"
                        onClick={() => history.push('/salesTransactions')}
                        size="large"
                        variant="contained"
                    >
                        {t('homePage:button.viewSalesTransactions')}
                    </Button>
                </Transaction>
            </Grid>
        </Grid>
    );
};

export default HomePageBody;
